// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__3IkI9","rootSmall":"AddTileButton_rootSmall__2Gt-e"};